module.exports = __webpack_public_path__ + "static/media/ico_setting_active.a0ec509c.svg";